import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ecommercesolution',
    templateUrl: './ecommercesolution.component.html',
    styleUrls: ['./ecommercesolution.component.css'],
    standalone: false
})
export class EcommercesolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
